import React from 'react';

const EmptyState = ({ icon = 'fa-inbox', title, description, action, className = '' }) => (
  <div className={`text-center py-12 sm:py-16 px-4 ${className}`}>
    <div className="w-16 h-16 rounded-2xl bg-slate-100 dark:bg-slate-700/60 flex items-center justify-center mx-auto mb-4">
      <i className={`fas ${icon} text-3xl text-slate-300 dark:text-slate-500`}></i>
    </div>
    {title && <p className="text-slate-700 dark:text-slate-200 font-semibold text-lg">{title}</p>}
    {description && <p className="text-sm text-slate-400 dark:text-slate-500 mt-1 max-w-sm mx-auto">{description}</p>}
    {action && <div className="mt-5 flex justify-center">{action}</div>}
  </div>
);

export default EmptyState;
